import { format } from 'date-fns'
import ApiService from './ApiService'

const AuthorizedPersonService = {
    _formatDate(date) {
        return format(date, 'yyyy-MM-dd')
    },

    async create(person) {
        try {
            const preparedPerson = {
                ...person,
                date_of_birth: person.date_of_birth ? this._formatDate(person.date_of_birth) : null,
            }
            const response = await ApiService.post('authorized_person.store', preparedPerson)
            return response.data
        } catch (error) {
            console.error('Error creating authorized person:', error)
            throw error
        }
    },

    async update(person) {
        try {
            const data = {
                ...person,
                date_of_birth: person.date_of_birth ? this._formatDate(person.date_of_birth) : null,
            }
            const response = await ApiService.post('authorized_person.update', data, {
                authorizedPerson: data.id,
            })
            return response.data
        } catch (error) {
            console.error('Error updating authorized person:', error)
            throw error
        }
    },

    async downloadPassport(authorizedPerson) {
        try {
            const fileName = `${authorizedPerson.first_name} ${authorizedPerson.last_name} passport`
            await ApiService.downloadFile('authorized_person_passport.download', fileName, {
                authorizedPerson: authorizedPerson.id,
            })
        } catch (error) {
            console.error('Error downloading passport:', error)
            throw error
        }
    },

    async deletePassport(authorizedPerson) {
        try {
            await ApiService.delete('authorized_person_passport.destroy', {
                authorizedPerson: authorizedPerson.id,
            })
        } catch (error) {
            console.error('Error downloading passport:', error)
            throw error
        }
    },

    async refreshRpsReport(personIds) {
        try {
            const response = await ApiService.post('authorized_person.refresh_rps_report', {
                person_ids: personIds,
            })
            return response.data
        } catch (error) {
            console.error('Error refreshing RPS report for authorized persons:', error)
            throw error
        }
    },

    async resolveRpsMatch(personId, entityIndex) {
        try {
            const response = await ApiService.post('authorized_person.resolve_rps_match', {
                person_id: personId,
                entity_index: entityIndex,
            })
            return response.data
        } catch (error) {
            console.error('Error resolving RPS match:', error)
            throw error
        }
    },

    async getRawDnbReport(authorizedPerson) {
        try {
            const response = await ApiService.get(
                'authorized_person.get_raw_dnb_report',
                authorizedPerson
            )
            return response.data
        } catch (error) {
            console.error('Error getting raw DNB report:', error)
            throw error
        }
    },
}

export default AuthorizedPersonService
